import React, { useCallback, useEffect, useState } from "react";
import "./styles.css";
import BackArrow from "../../images/backArrow2.svg";
import location from "../../images/location.svg";
import locationBlue from "../../images/locationBlue.svg";
import StyledInput from "../styleInput";
import debounce from "lodash/debounce";
import MapContainer from "../MapContainer";
import { uniqueId } from "lodash";

const AddRestStops = ({
  popularRestStops,
  getPickupPoints,
  placeSearchResults,
  assignedStops,
  setAssignedStops,
  setShowPostAssigned,
  setShowRestStopAdd,
  setShowRestStopHome,
  mmiSignKey,
  sourceValue,
  destinationValue,
}) => {
  const [stopValue, setStopValue] = useState(null);
  const [totalDistance, setTotalDistance] = useState(null);
  const debouncePickupSearch = useCallback(
    debounce((value) => {
      getPickupPoints(value);
    }, 500),
    []
  );
  useEffect(() => {
    const initialDist = getDistance(
      sourceValue.location.lat,
      sourceValue.location.lon,
      destinationValue.location.lat,
      destinationValue.location.lon
    );
    setTotalDistance(initialDist);
  }, []);
  const getDistance = (lat1, lon1, lat2, lon2) => {
    lat1 = parseFloat(lat1);
    lon1 = parseFloat(lon1);
    lat2 = parseFloat(lat2);
    lon2 = parseFloat(lon2);
    let R = 3958.8;
    let rlat1 = lat1 * (Math.PI / 180);
    let rlat2 = lat2 * (Math.PI / 180);
    let difflat = rlat2 - rlat1;
    let difflon = (lon2 - lon1) * (Math.PI / 180);
    const distanceBuffer = 1;
    let d =
      2 *
      R *
      Math.asin(
        Math.sqrt(
          Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(rlat1) *
              Math.cos(rlat2) *
              Math.sin(difflon / 2) *
              Math.sin(difflon / 2)
        )
      );
    return d * 1.60934 * distanceBuffer;
  };
  const onNextClick = () => {
    if (assignedStops.length) {
      setShowRestStopAdd(false);
      setShowPostAssigned(true);
    } else {
      alert("Please select rest stops");
    }
  };

  const onHeaderBackClick = () => {
    setShowRestStopAdd(false);
    if (assignedStops.length) {
      setShowPostAssigned(true);
      setShowRestStopHome(false);
    } else {
      setShowPostAssigned(false);
      setShowRestStopHome(true);
    }
  };
  const setStopInput = (value) => {
    if (value.length >= 0) {
      setStopValue(value);
      value.length > 0 ? debouncePickupSearch(value) : setStopValue(null);
    }
  };

  const checkForDistance = (stop) => {
    const distSrcToPoint = getDistance(
      sourceValue.location.lat,
      sourceValue.location.lon,
      stop.lat || stop.latitude,
      stop.long || stop.longitude
    );
    const distPointToDest = getDistance(
      stop.lat || stop.latitude,
      stop.long || stop.longitude,
      destinationValue.location.lat,
      destinationValue.location.lon
    );
    const distanceSum = distSrcToPoint + distPointToDest;
    if (distanceSum > 1.25 * totalDistance) {
      return true;
    } else {
      return false;
    }
  };
  const onAddClick = (element) => {
    let stopsAssigned = [...assignedStops];
    if (stopsAssigned.length < 5) {
      const index = stopsAssigned.findIndex((stop) => stop.id === element.id);
      if (index === -1) {
        stopsAssigned.push(element);
      } else {
        stopsAssigned.splice(index, 1);
      }
      setAssignedStops(stopsAssigned);
    } else {
      alert("Number of rest stops can not exceed the maximum limit of 5");
    }
  };

  const onRemoveClick = (element) => {
    let stopsAssigned = [...assignedStops];
    const index = stopsAssigned.findIndex((stop) => stop.id === element.id);

    if (index !== -1) {
      stopsAssigned.splice(index, 1);
    }

    setAssignedStops(stopsAssigned);
  };
  const onAddSearchClick = (element) => {
    let stopsAssigned = [...assignedStops];
    if (stopsAssigned.length < 5) {
      const index = stopsAssigned.findIndex(
        (stop) =>
          stop.place_name === element.place_name &&
          stop.place_address === element.place_address
      );

      if (index === -1) {
        const checkIfPointIsFar = checkForDistance(element);
        if (checkIfPointIsFar) {
          if (
            window.confirm(
              `${element.place_name} is very far from your current route. Do you still want to add?`
            )
          ) {
            stopsAssigned.push(element);
          }
        } else {
          stopsAssigned.push(element);
        }
      } else {
        stopsAssigned.splice(index, 1);
      }

      setAssignedStops(stopsAssigned);
    } else {
      alert("Number of rest stops can not exceed the maximum limit of 5");
    }
  };

  const onRemoveSearchClick = (element) => {
    let stopsAssigned = [...assignedStops];
    const index = stopsAssigned.findIndex(
      (stop) =>
        stop.place_name === element.place_name &&
        stop.place_address === element.place_address
    );

    if (index !== -1) {
      stopsAssigned.splice(index, 1);
    }

    setAssignedStops(stopsAssigned);
  };
  const ifItemInAssignedStops = (element) => {
    return assignedStops.some((stop) => stop.id === element.id);
  };
  const ifItemInAssignedStopsSearch = (element) => {
    return assignedStops.some(
      (stop) =>
        stop.place_name === element.place_name &&
        stop.place_address === element.place_address
    );
  };
  return (
    <div className="addStopsContainer">
      <div className="heading">
        <img
          src={BackArrow}
          alt="Back arrow"
          className="backArrow"
          onClick={() => {
            onHeaderBackClick();
          }}
        />
        Add Rest Stops
      </div>
      <div className="bottomContent">
        <div className="placeSearch">
          <div className="searchWrapper">
            <StyledInput
              type="text"
              name="discountValue"
              value={stopValue}
              onChange={setStopInput}
              placeholder="Search by rest stop name"
              errorMsg={""}
              flag={true}
              isFromAddStops={true}
            />
          </div>
          {!stopValue && (
            <>
              <div className="popularStops">
                <div className="headSubText">
                  Popular rest stops on this route
                </div>
                {popularRestStops.map((element) => (
                  <div key={element.name} className="popularRestStop">
                    <div className="stopName">{element.name}</div>
                    <div className="stopAddress">{element.address}</div>
                    <div className="addButtonContainer">
                      {ifItemInAssignedStops(element) ? (
                        <div
                          className="removeButton"
                          onClick={() => {
                            onRemoveClick(element);
                          }}
                        >
                          Remove
                        </div>
                      ) : (
                        <div
                          className="addButton"
                          onClick={() => {
                            onAddClick(element);
                          }}
                        >
                          + Add
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>{" "}
            </>
          )}
          {stopValue && placeSearchResults && (
            <>
              <div className="searchStops">
                {/* <div className="paddindDiv"> */}
                <div className="headSubTextSearch">Search Suggestions</div>
                {placeSearchResults.map((element, index) => (
                  <div
                    key={element.name}
                    className={
                      ifItemInAssignedStopsSearch(element)
                        ? "searchRestStopsBlue"
                        : "searchRestStops"
                    }
                  >
                    <img
                      className="locationIcon"
                      src={
                        ifItemInAssignedStopsSearch(element)
                          ? locationBlue
                          : location
                      }
                      alt="location"
                    />
                    <div className="placeDetails">
                      <div
                        className={
                          ifItemInAssignedStopsSearch(element)
                            ? "searchStopNameBlue"
                            : "searchStopName"
                        }
                      >
                        {element.place_name}
                      </div>
                      <div
                        className={
                          ifItemInAssignedStopsSearch(element)
                            ? "searchStopAddressBlue"
                            : "searchStopAddress"
                        }
                      >
                        {element.place_address}
                      </div>
                    </div>
                    {ifItemInAssignedStopsSearch(element) ? (
                      <div
                        className="removeButton"
                        onClick={() => {
                          onRemoveSearchClick(element);
                        }}
                      >
                        Remove
                      </div>
                    ) : (
                      <div
                        className="addButton"
                        onClick={() => {
                          onAddSearchClick(element);
                        }}
                      >
                        + Add
                      </div>
                    )}
                  </div>
                ))}

                {/* </div> */}
                <div className="borderLine"></div>
                <div className="paddindDiv">
                  <div className="headSubText">
                    Popular rest stops on this route
                  </div>
                  {popularRestStops.map((element) => (
                    <div key={element.name} className="popularRestStop">
                      <div className="stopName">{element.name}</div>
                      <div className="stopAddress">{element.address}</div>
                      <div className="addButtonContainer">
                        {ifItemInAssignedStops(element) ? (
                          <div
                            className="removeButton"
                            onClick={() => {
                              onRemoveClick(element);
                            }}
                          >
                            Remove
                          </div>
                        ) : (
                          <div
                            className="addButton"
                            onClick={() => {
                              onAddClick(element);
                            }}
                          >
                            + Add
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>{" "}
            </>
          )}
          {stopValue && !placeSearchResults && (
            <>
              <div className="popularStops">
                Searching for the stops. .. ...
              </div>{" "}
            </>
          )}
        </div>
        <div className="mapContainer">
          <MapContainer
            assignedStops={assignedStops}
            mmiSignKey={mmiSignKey}
            sourceValue={sourceValue}
            destinationValue={destinationValue}
          />
        </div>
        <div className="addedStopsContainer">
          <div className="assignedStopsHead">
            <div className="addedHead">Assigned Rest Stops</div>
            <div className="stopsNextButton" onClick={() => onNextClick()}>
              Next
            </div>
          </div>
          <div className="assignedStops">
            {assignedStops.map((element) => (
              <div key={element.name} className="popularRestStop">
                <div className="stopName">
                  {element.name || element.place_name}
                </div>
                <div className="stopAddress">
                  {element.address || element.place_address}
                </div>
                <div className="addButtonContainer">
                  <div
                    className="removeButton"
                    onClick={() => {
                      onRemoveClick(element);
                    }}
                  >
                    Remove
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRestStops;
